import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from 'next/link'
import dynamic from 'next/dynamic'
import DButton from '../../components/elements/DButton';

import Image from 'next/image'
import Navbar from "../../components/Layouts/Navbar";
import Banner from "../../components/Consulting/Static/Banner";
import Introduction from "../../components/Consulting/Static/Introduction";
import OurPerspective from "../../components/Consulting/Static/OurPerspective";
import Breadcrumb from "../../components/Layouts/Breadcrumb";
import RelatedInsights from "../../components/Consulting/Static/RelatedInsights";
import { ConsultingData } from "../../components/Consulting/data/ConsultingListData";
import Footer from '../../components/Layouts/Footer';
import HeroBanner from "../../components/Common/HeroBanner";
import SectionHeading from "../../components/Common/SectionHeading";
import AboutSection from "../../components/Consulting/ConferenceCoverage/AboutSection";
import ProcessSection from "../../components/Consulting/ConferenceCoverage/ProcessSection";
import AdvanceSection from "../../components/Consulting/ConferenceCoverage/AdvanceSection";
import JourneySection from "../../components/Consulting/ConferenceCoverage/JourneySection";
import ServiceSection from "../../components/Consulting/ConferenceCoverage/ServiceSection";
import PastEventSection from "../../components/Consulting/ConferenceCoverage/PastEventSection";
import GetInTouchSection from "../../components/Consulting/ConferenceCoverage/GetInTouchSection";
import TabSection from "../../components/Consulting/CompetitiveIntelligence/TabSection";
import BlogSection from "../../components/Consulting/CompetitiveIntelligence/BlogSection";
import AccordionSection from "../../components/Consulting/CompetitiveIntelligence/AccordionSection";
import OurApproach from "../../components/Consulting/PrimaryResearch/OurApproach";
import OurApproachCI from "../../components/Consulting/CITracking/OurApproachCI";
import TrackingCoverageSection from "../../components/Consulting/CITracking/TrackingCoverageSection";
import BenefitsOfFirstMoverSection from "../../components/Consulting/CITracking/BenefitsOfFirstMoverSection";


import Connect from "../../components/Consulting/Common/Connect";
import Therapeutic from "../../components/Consulting/PrimaryResearch/Therapeutic";
import CaseStudiesSection from "../../components/Consulting/CompetitiveIntelligence/CaseStudiesSection";
import OurDifferentiatorsSection from "../../components/Consulting/CompetitiveIntelligence/OurDifferentiatorsSection";
import OurUniqueSection from "../../components/Consulting/CompetitiveIntelligence/OurUniqueSection";
import Solutions from "../../components/Consulting/PrimaryResearch/Solutions";
import ReadyToTalk from "../../components/Consulting/PrimaryResearch/ReadyToTalk";
import WhyDI from "../../components/Consulting/PrimaryResearch/WhyDI";
import Experience from "../../components/Consulting/PrimaryResearch/Experience";
import CaseStudy from "../../components/Consulting/PrimaryResearch/CaseStudy";
import ValueProposition from "../../components/Consulting/PrimaryResearch/ValueProposition";
import TrackingProcess from "../../components/Consulting/CITracking/TrackingProcess";
import LeverageSection from "../../components/Consulting/CITracking/LeverageSection";
import TrackingInsights from "../../components/Consulting/CITracking/TrackingInsights";
import OurPortfolio from "../../components/Consulting/CITracking/OurPortfolio";
import ChooseDI from "../../components/Consulting/CITracking/ChooseDI";
import DetailsProcess from "../../components/Consulting/ConferenceCoverage/DetailsProcess";
import ContactSection from "../../components/Common/ContactSection";
import { homeNewsLetterList, ciTrackingNewsLetterList, primaryResearchNewsLetterList } from "../../components/Common/DataSet/NewsLetterData";
import { PastEventList, aboutList, advantageList, detailedProcessList, journeyList, serviceList } from "../../components/Consulting/ConferenceCoverage/DataSet/MainData";
import { contactList, ourValueList, newsLetterList, caseStudiesList, tabList } from "../../components/Consulting/CompetitiveIntelligence/DataSet/MainData";
import CommonPopup from '../../components/PopupForm/CommonPopup';
import * as Yup from 'yup';
import Head from "next/head";
import axios from 'axios'
import EventBooking from '../../components/Conference/EventBooking';


const NewsLetterSection = dynamic(() => import('../../components/Common/NewsLetterSection', { ssr: false }))

export default function Consulting({ metaDetails, slug }) {


  const [DataRendered, setDataRendered] = useState(false);
  useEffect(() => {
    setDataRendered(true)
  }, [])

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const options = {
    btn_name: "Submit"
  }

  const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/

  const fields = [
    {
      name: 'name',
      label: '',
      placeholder: 'Full Name*',
      validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'company_name',
      label: '',
      placeholder: 'Company Name',
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'phone',
      label: '',
      placeholder: 'Phone Number',
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'email',
      type: 'email',
      label: '',
      placeholder: 'Add Your Company E-mail Address*',
      validation: Yup.string().email('Invalid email').required('Email is required'),
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'

    },
    {
      name: 'project_overview',
      label: '',
      placeholder: 'Project Overview',
      type: 'textarea',
      col_row: 2,
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'project_goal',
      label: '',
      placeholder: 'Project Goal',
      type: 'textarea',
      col_row: 2,
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'scope_of_work',
      label: '',
      placeholder: 'Scope of Work',
      type: 'textarea',
      col_row: 2,
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'submission_request',
      label: '',
      placeholder: 'Submission Request',
      type: 'textarea',
      col_row: 2,
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'submit_date',
      label: '',
      type: 'date',
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'file_name',
      label: '',
      type: 'file',
      className: 'block text-gray-700 text-sm w-full py-2 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
    },
  ];

  const router = useRouter();
  const { slug:slug_url } = router.query;
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(false);

  useEffect(() => {
    if (slug_url) {
      if (slug_url in ConsultingData) {
        setData(ConsultingData[slug_url]);
        setStatus(true);
      } else {
        router.push("/404");
      }
    }
  }, [slug_url, router]);

  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)
  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])


  const [metaData, setMetaData] = useState(null);
  const [metaSlug, setmetaSlug] = useState(null);

  useEffect(() => {
    ciTrackingNewsLetterList.click=openModal;
    try {
      const slug_full = slug_url;
      const complete_url = window.location.href;
      setmetaSlug(complete_url)
      axios.get(process.env.API_URL + '/meta/' + slug_full).then((res) => {
        if (res.data?.code == 200) {
          setMetaData(res.data)
        } else {
        }
      }).catch((error) => {
        // 
      })
    } catch (err) {

    }
  }, [])

  return (
    <>
      <Navbar />
      <Head>
        <title>{(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "}</title>
        <meta property="og:title" content={(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "} />
        <meta property="og:description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
        <meta name="twitter:title" content={(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "} />
        <meta name="twitter:description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />

        <meta property="og:url" content={(slug) ? slug : metaSlug} />
        <meta name="description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
        <meta name="keywords" content={(metaDetails != undefined) ? metaDetails.meta_keywords : (metaData) ? metaData?.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."} />
      </Head>
      {
        slug_url == "ci-tracking"
          ? (
            <>
              <HeroBanner
                background={process.env.IMG_CDN + "img/consulting/jpg/ci-tracking.jpg"}
                title={<>CI Tracking</>}
                description={<>DelveInsight&apos;s systematic competitive intelligence (CI) tracking in the healthcare industry keeps clients informed about trends, aiding strategic decision-making. Our healthcare CI tracking services empower clients to make informed decisions about their strategies and operations. In the competitive Pharma/Biotech industry, our continuous coverage and updates bridge the gap between success and outstanding success.</>}
              />
             
              <Breadcrumb />
              <OurApproachCI className="text-center" title="Our Approach" />
              <NewsLetterSection data={ciTrackingNewsLetterList}/>
              <TrackingCoverageSection title="DelveInsight’s Competitive Intelligence Tracking Coverage" />
              <BenefitsOfFirstMoverSection title="Reap the benefits of being a First Mover" />
              <OurPortfolio title="Our Portfolio of Competitive Intelligence and Consulting Solutions"/>
              <TrackingProcess title="Competitive Intelligence Tracking Process" />
              <LeverageSection title="Leverage our Competitive Intelligence Services" />
              <TrackingInsights title="Leverage our Competitive Intelligence Tracking Insights to accurately" />
              <ChooseDI title="Why Choose DelveInsight?" />
            </>
          ) : slug_url == "primary-research-services" ? (
            <>
              <HeroBanner
                background={process.env.IMG_CDN + "img/banner/primary-research-services.webp"}
                title={<>Primary Market Research</>}
                description={<>Expertly crafted primary research techniques provide in-depth corporate intelligence and competitive analysis based on real-time primary research. DelveInsight offers timely and practical insights on strategic news updates to senior leadership, aiding and improving pharmaceutical competitive intelligence.</>}
              />
              <Breadcrumb />
              <OurApproach title="Our Approach" />
              <NewsLetterSection data={primaryResearchNewsLetterList} />
              <Solutions title="Primary Market Research Solutions" />
              <ReadyToTalk title="Ready to Talk" />
              <Therapeutic title="Exhaustive Therapeutic Area Monitoring" />
              <WhyDI title="Why Choose DelveInsight?" shortDescription="DelveInsight has positioned itself as an organization that is highly regarded by healthcare clients across the globe for achieving competitive advantage through our exemplary primary market research outcomes. These primary research benefits are realized by selecting DelveInsight as a trusted research provider:" />
              <Experience title="More than 24 years of Experience" shortDescription="Utilize our primary intelligence on each step of the way. Create a purposeful plan for success as we aid you in designing roadmaps that provide successful outcomes, leading to the execution of strategies to perfection." />
              <CaseStudy title="Case Studies" />
              <ValueProposition title="Our Value Propositions" />
            </>
          ) : slug_url == "conference-coverage-services" ? (
            <>
              <HeroBanner
                background={process.env.IMG_CDN + "img/researchCoverage/congress-intelligence-and-conference-coverage.png"}
                customClass="lg:text-black text-white"
                title={<>Congress Intelligence and Conference Coverage</>}
                description={<>Tracking key conferences to provide intelligent insights</>}
                buttonOnBanner={<>
                  <div className="flex grid-cols-1 sm:grid-cols-4">
                    <DButton title="Request a Quote" customClass='m-0 lg:mt-3 mr-2 sm:mt-0' onclick={openModal} />
                    <CommonPopup isOpen={isModalOpen} closeModal={closeModal}
                      fields={fields}
                      options={options}
                      page_name="Conference Coverage Popup"
                      form_name="request-for-proposal"
                      formTitle="Request For Proposal"
                      endpoint="/enquiry/request-for-proposal"
                    />
                  </div>
                </>}
              />
              <Breadcrumb />
              <EventBooking/>
              <ProcessSection />
              {scrolledStatus &&
                <>
                  <NewsLetterSection data={homeNewsLetterList} />
                  <DetailsProcess data={detailedProcessList} />
                  <AboutSection data={aboutList} />
                  <AdvanceSection data={advantageList} />
                  <JourneySection data={journeyList} />
                  <ServiceSection data={serviceList} />
                  <PastEventSection data={PastEventList} />
                  <GetInTouchSection
                    page_name="Conference Coverage Page"
                    form_name="conference-coverage-page-form"
                    endpoint="/enquiry/conference-coverage"
                  />
                </>
              }
            </>
          ) : slug_url == "competitive-intelligence-services" ? (
            <>
              <HeroBanner
                background={process.env.IMG_CDN + "img/consulting/jpg/service/competitive-intelligence-services.png"}
                title={<>Healthcare Competitive Intelligence Services</>}
                description={<> Real-time, Actionable, and Strategic Insights</>}
                buttonOnBanner={<>
                  <div className="flex grid-cols-1 sm:grid-cols-4">
                    <DButton title="Request for Solutions" customClass='m-0 lg:mt-3 mr-2 sm:mt-0' onclick={openModal} />
                    <CommonPopup isOpen={isModalOpen} closeModal={closeModal}
                      fields={fields}
                      options={options}
                      page_name="Competitive Intelligence Services"
                      form_name="request-for-proposal"
                      formTitle="Request For Proposal"
                      endpoint="/enquiry/request-for-proposal"
                    />
                  </div>
                </>}
              />
              <Breadcrumb />
              <OurUniqueSection data={ourValueList} />
              {scrolledStatus &&
                <>
                  <TabSection title="Our Competitive Intelligence Offerings" data={tabList} />
                  <OurDifferentiatorsSection />
                  <CaseStudiesSection data={caseStudiesList} />
                  <NewsLetterSection data={newsLetterList} />
                  <BlogSection />
                  <ContactSection
                    data={contactList}
                    page_name="Competitive Intelligence Page"
                    form_name="competitive-intelligence-page-form"
                    endpoint="/enquiry/get-expert-cis"
                  />

                </>
              }
            </>
          ) : (
            <>
              {/* <Banner
                title={status ? data?.banner?.title : ""}
                description={status ? data.banner?.description : ""}
                service={status ? data.banner?.service : ""}
              /> */}
              <HeroBanner
                background={process.env.IMG_CDN + data.banner?.url}
                title={status ? data.banner?.title : ""}
                description=<>{status ? data.banner?.description : ""}</>
                buttonOnBanner={<>
                    <DButton title="Request for Solutions" customClass='text-left' onclick={openModal} />
                    <CommonPopup isOpen={isModalOpen} closeModal={closeModal}
                      fields={fields}
                      options={options}
                      page_name="Competitive Intelligence Services"
                      form_name="request-for-proposal"
                      formTitle="Request For Proposal"
                      endpoint="/enquiry/request-for-proposal"
                    />
                </>}
                service={status ? data.banner?.service : ""}
              />
              <Breadcrumb />
              <Introduction
                description={status ? data.introduction?.description : ""}
                points={status ? data.introduction?.points : []}
              />
              <OurPerspective
                title="Our Perspective"
                description={status ? data.perspective?.description : ""}
                pointsHeading={status ? data.perspective?.pointsHeading : ""}
                perspectiveItems={status ? data.perspective?.perspectiveItems : []}
              />
              <NewsLetterSection data={newsLetterList} />
              <RelatedInsights title="Related Insights" />
            </>
          )
      }
      <Footer />
    </>
  );
}


export async function getServerSideProps({ req, res, resolvedUrl }) {

  let slug = resolvedUrl;
  let full_slug = process.env.APP_URL + resolvedUrl;
  if (slug.includes('/_next/')) {
    // checking if it making request json file then skip to fetch Meta Data
    return {
      props: {
        metaDetails: {
          meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
        },
        slug: full_slug
      }
    };
  } else {
    // Remove the trailing slash, if any
    const cleanedSlug = slug.replace(/\/$/, '');
    const NewSlug = slug.replace('/consulting/', '');

    try {
      const response = await axios.get(process.env.API_URL + '/meta/' + NewSlug);
      const metaDetails = response.data;

      if (metaDetails == undefined || metaDetails == '' || metaDetails == null || metaDetails?.code === 404) {
        return {
          props: {
            metaDetails: {
              meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
              meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
              meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
            },
            slug: NewSlug
          }
        }
      } else {
        return {
          props: {
            metaDetails: metaDetails,
            slug: NewSlug
          },
        };

      }
    } catch (error) {
      // console.error('Error fetching API data:', error);

      return {
        props: {
          metaDetails: {
            meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
            meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
          },
          slug: full_slug
        },
      };
    }
  }
}